var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import "./StackPanelStyle.scss";
var StackPanelComponent = /** @class */ (function () {
    function StackPanelComponent(children, options) {
        this.children = children;
        this.options = __assign({ orientation: "horizontal", valign: "stretch" }, options);
    }
    StackPanelComponent.prototype.isEqual = function (node) {
        return this.__proto__ === node.__proto__;
    };
    StackPanelComponent.prototype.render = function () {
        var _this = this;
        var c = this.options.orientation === "horizontal" ? "stackpanel-comp hstackpanel" : "stackpanel-comp vstackpanel";
        if (this.options.responsive) {
            c += " responsive";
        }
        if (this.options.wrap) {
            c += " wrap";
        }
        if (this.options.class) {
            c += " " + this.options.class;
        }
        var va = this.options.valign;
        var s = "align-items:" + (va === "top" ? "flex-start" : (va === "bottom" ? "flex-end" : va));
        if (this.options.style) {
            s += ";" + this.options.style;
        }
        return {
            tag: "div", attr: { class: c, style: s },
            children: this.children.map(function (x, idx) { return x != null && x._is_splitter === true ? x : ({
                tag: "div",
                attr: { style: _this.getSize(idx) + (_this.options.flexForChildren ? ";display:flex" : "") },
                children: [x]
            }); })
        };
    };
    StackPanelComponent.prototype.getSize = function (idx) {
        if (this.options.sizes != null && this.options.sizes[idx] != null) {
            var s = this.options.sizes[idx];
            if (s === "*") {
                return undefined;
            }
            if (this.options.orientation === "vertical") {
                return "height: " + s;
            }
            else {
                return "width:" + s;
            }
        }
        return "flex-grow:1;";
    };
    return StackPanelComponent;
}());
export { StackPanelComponent };
